import { InfluencerProfileAudience, InfluencerProfileAudienceProps } from '../shared';

type InfluencerThreadsProfileAudienceProps = InfluencerProfileAudienceProps;

export const InfluencerThreadsProfileAudience = (props: InfluencerThreadsProfileAudienceProps) => (
  <InfluencerProfileAudience {...props} />
);
